<lgb-header-gradient [height]="200"></lgb-header-gradient>
<form #form="ngForm" class="screen-container gradient" [loading]="loading()">
	@if(card()){
		<div class="carousel rounded-box w-full">
			@for(lang of getLangs(); track lang){
				<div class="carousel-item w-full">
					<div class="image-container w-full">
						<!-- <img [altImg]="[getImage(lang)]" class="w-full"/> -->
						<img [altImg]="[getImage(lang)]" class="w-full"/>
						<input id="img-{{lang}}" (change)="setImage($event, lang)" name="img[{{lang}}]" type="file" class="img-none"/>
						<div class="edit-container">
							<div class="edit-icon">
								<a [routerLink]="router.get('admin-card-list')" class="back add-fav glass rounded-full bg-black/40">
									<i class="fa-regular fa-chevron-left"></i>
								</a>
								<label for="img-{{lang}}" class="add-fav glass rounded-full bg-black/40 mb-3">
									<i class="fa-light fa-pen"></i>
								</label>
							</div>
							<div class="lang-container glass bg-black/40">Langue : {{lang | uppercase}}</div>
						</div>
					</div>
				</div>
			}
			<lgb-swipe-hint></lgb-swipe-hint>
		</div>
	}
	<div class="mb-4">
		<lgb-message [(msg)]="msg" [(error)]="error"></lgb-message>
	</div>

	<div class="tabs tabs-box">
		@for(l of getLangs(); track l){
		  <a (click)="lang.set(l)" [ngClass]="{'tab-active': lang()==l}" class="tab">{{l | uppercase}}</a>
		}
	</div>

	<!-- name -->
	<label class="floating-label my-4">
	  <span>Nom</span>
	  <input type="text" [ngModel]="name()?.text" (ngModelChange)="setName($event)" placeholder="Nom" name="name" class="input input-md w-full" />
	</label>

	<!-- numéro -->
	<label class="floating-label my-4">
	  <span>Numéro</span>
	  <input type="text" [(ngModel)]="card().numero" placeholder="Numéro" name="num" class="input input-md w-full" required />
	</label>

	<!-- rarity -->
	<select [(ngModel)]="card().rarity" name="rarity" class="select w-full mb-4" required>
	    <option [ngValue]="undefined" selected>Rareté</option>
	  	@for(rarity of rarities(); track rarity.ref){
		    <option value="{{rarity.ref}}">{{rarity.name}}</option>
	  	}
	</select>

	<!-- categ -->
	<select [(ngModel)]="card().categ" name="cardCateg" class="select w-full mb-4" required>
	    <option [ngValue]="undefined" selected>Categorie</option>
	  	@for(categ of categs(); track categ){
		    <option [value]="categ.ref">[{{categ.type}}] {{categ.name}}</option>
	  	}
	</select>

	<!-- set -->
	<select [(ngModel)]="card().cardSet" name="cardSet" class="select w-full mb-4" required>
	    <option [ngValue]="undefined" selected>Serie</option>
	  	@for(cardSet of cardSets(); track cardSet){
		    <option value="{{cardSet.ident}}">[{{cardSet.abbreviation}}] {{cardSetName(cardSet)}}</option>
	  	}
	</select>

	<!-- Feature -->
	<div class="collapse collapse-plus bg-base-100 border-base-300 border mb-4">
	  <input type="checkbox" class="peer" />
	  <div class="collapse-title font-semibold">Features</div>
	  <div class="collapse-content text-sm">
	  	@for(feat of getFeatures(); track feat){
	  		<p class="title-feat mb-1">{{getNameFeat(feat)}}</p>
	  		<p class="mb-4">{{feat.text}}</p>
	  	}
	  	@empty{
	  		Aucune features pour cette carte.
	  	}
	  </div>
	</div>

	<!-- ThirdParty -->
	<div class="collapse collapse-plus bg-base-100 border-base-300 border">
	  <input type="checkbox" class="peer" />
	  <div class="collapse-title font-semibold">Third parties</div>
	  <div class="collapse-content text-sm">
	  	@for(party of card()?.thirdParties; track party){
			<label class="floating-label my-4">
			  <span>{{getMarketPlace(party.marketplace).name}}</span>
			  	<div class="join w-full">
				  <input type="text" [(ngModel)]="party.remoteId" placeholder="Id pour {{getMarketPlace(party.marketplace).name}}" name="marketplace-{{party.marketplace}}" class="input input-md w-full" />
		      	  <button (click)="rmParty(party.marketplace)" class="text-error btn join-item"><i class="fa-regular fa-trash"></i></button>
				</div>
			</label>
	  	}

	  	@if(getMarketDispo().length){
		  	<div class="join w-full mb-4">
			  <select #market class="select join-item">
			  	@for(market of getMarketDispo(); track market.ref){
				    <option value="{{market.ref}}">{{market.name}}</option>
			  	}
			  </select>
		      <button (click)="addParty(market.value)" class="btn join-item"><i class="fa-regular fa-plus-large"></i></button>
			</div>
		}
	  </div>
	</div>

  	<div class="btn-container mt-4" [ngClass]="{'btn-continer-serial': !isNew()}">
  		@if(!isNew()){
	  		<button (click)="rmCard()" class="btn btn-soft btn-error">Supprimer</button>
	  	}
		<button (click)="setCard()" class="btn btn-primary btn-gradient" [disabled]="form.invalid">{{((isNew())? 'Ajouter' : 'Modifier')}}</button>
	</div>
</form>